import React from 'react'
import { Row, Col, Nav } from 'react-bootstrap';
import { Link } from "react-router-dom";
import './Header.css';
import logo from '../images/logo.png';
import logoPuyd from '../images/logo-puyd.png';

function Header() {
    let onlinechallenge = window.location.pathname == '/onlinechallenge';
    let ongroundchallenge = window.location.pathname == '/ongroundchallenge';
    return (
        <div className="mb-5">
            <Row className="align-items-end">
                <Col xs={6} md={3}>
                    <Link to="/">
                        <img src={logo} alt="Gulf Oil India" className="logo mr-4 align-bottom img-fluid" />
                    </Link>
                </Col>
                <Col xs={6} md={3} className="text-right order-md-last">
                    <img src={logoPuyd} alt="Pick-up Your Dream" className="logo-puyd img-fluid" />
                </Col>
                <Col xs={12} md={6} className="text-center align-self-center">
                    {(() => {
                        if (onlinechallenge || ongroundchallenge) {
                            return (
                                <Nav className="justify-content-center my-4">
                                    <Nav.Item>
                                        <Nav.Link href="/onlinechallenge" className={onlinechallenge ? 'active' : ''}>On-Line Challenge</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link href="/ongroundchallenge" className={ongroundchallenge ? 'active' : ''}>On-Ground Challenge</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            )
                        }
                    })()}
                </Col>
            </Row>
        </div>
    );
}

export default Header;